import {fixedScroll} from "../../modules/disablescroll";

const $class = {
    active: 'js-isActive'
}

const $burger = {
    btn: $('.c-navbar__nav--burger'),

    spans: {
        one: $('.c-navbar__nav--burger span:nth-child(1)'),
        two: $('.c-navbar__nav--burger span:nth-child(2)'),
        three: $('.c-navbar__nav--burger span:nth-child(3)'),
        four: $('.c-navbar__nav--burger span:nth-child(4)'),
    }
}

function openBurger() {
    $burger.spans.one.css('transform', 'translateY(12px)');
    $burger.spans.two.css('transform', 'translateY(4px)');
    $burger.spans.three.css('transform', 'translateY(-4px)');
    $burger.spans.four.css('transform', 'translateY(-12px)');

    setTimeout(function () {

        $burger.spans.one.css('transform', 'translateY(12px) rotate(45deg)');

        $burger.spans.two.css({
            transform: 'translateY(4px)',
            opacity: 0
        });
        $burger.spans.three.css({
            transform: 'translateY(-4px)',
            opacity: 0
        });
        $burger.spans.four.css('transform', 'translateY(-12px) rotate(-45deg)');
    }, 300);
}

function closeBurger() {


    $burger.spans.one.css('transform', 'translateY(12px) rotate(0deg)');

    $burger.spans.two.css({
        transform: 'translateY(4px)',
        opacity: 1
    });
    $burger.spans.three.css({
        transform: 'translateY(-4px)',
        opacity: 1
    });
    $burger.spans.four.css('transform', 'translateY(-12px) rotate(-0deg)');

    setTimeout(function () {
        $burger.spans.one.css('transform', 'translateY(0px)');
        $burger.spans.two.css('transform', 'translateY(0px)');
        $burger.spans.three.css('transform', 'translateY(0px)');
        $burger.spans.four.css('transform', 'translateY(0px)');
    }, 300);
}


const $navbar = {
    menu: $('.c-navbar__nav--menu'),
    items: $('.c-navbar__nav--menu li'),
}


$burger.btn.click(function () {
    if (!$(this).hasClass($class.active)) {
        $(this).addClass($class.active);
        $navbar.menu.addClass($class.active);
        $navbar.menu.slideDown({
            duration: '300',
            done: function () {
                $(this).css({
                    display: "flex"
                })
            }
        });

        setTimeout(function () {
            $navbar.items.css('opacity', 1);
        }, 300);

        fixedScroll('enable');
        openBurger();

    } else {
        $(this).removeClass($class.active);
        $navbar.menu.removeClass($class.active);
        $navbar.items.css('opacity', 0);
        setTimeout(function () {
            $navbar.menu.slideUp({
                duration: '300',
            });
        }, 300);
        fixedScroll('disable');
        closeBurger();
    }
});


if (Math.floor(window.scrollY) > 100) {
    $('.c-navbar').addClass('js-isSticky');
}

$(window).on('scroll', function () {

    let $windowScroll = Math.floor(window.scrollY);
    let $navbar = $('.c-navbar');

    if ($windowScroll < 100) {
        $navbar.removeClass('js-isSticky');
    } else {
        $navbar.addClass('js-isSticky');
    }
});
